import { render, staticRenderFns } from "./FlashcardsResult.vue?vue&type=template&id=28a98052&scoped=true&"
import script from "./FlashcardsResult.vue?vue&type=script&lang=js&"
export * from "./FlashcardsResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a98052",
  null
  
)

export default component.exports